module.exports = "/fonts/vendor/@flaticon/flaticon-uicons/css/uicons-solid-straight-W4CCEH4W.eot?e704a0f26ecd5add261165f7ab56bdc3";